/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
export const SET_SORT_BY = 'SET_SORT_BY';
export function setSortBy(listName, value) {
  return {
    type: SET_SORT_BY,
    payload: { [listName]: value },
  };
}

export const SET_SORT_BY_REVERSED = 'SET_SORT_BY_REVERSED';
export function setSortByReversed(listName, value) {
  return {
    type: SET_SORT_BY_REVERSED,
    payload: { [listName]: value },
  };
}

export const SET_SELECTED_DROPDOWN_ITEM = 'SET_SELECTED_DROPDOWN_ITEM';
export function setSelectedDropdownItem(key, value) {
  return {
    type: SET_SELECTED_DROPDOWN_ITEM,
    payload: { [key]: value },
  };
}

export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export function setSelectedItems(selectionName, items, selected) {
  return {
    type: SET_SELECTED_ITEMS,
    payload: { selectionName, items, selected },
  };
}

export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export function setSelectedItem(selectionName, item, selected) {
  return {
    type: SET_SELECTED_ITEM,
    payload: { selectionName, item, selected },
  };
}

export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export function setPageSize(pageSize) {
  return { type: SET_PAGE_SIZE, payload: pageSize };
}

export const TOGGLE_ACCORDION_ITEM = 'TOGGLE_ACCORDION_ITEM';
export function toggleAccordionItem(name, item) {
  return { type: TOGGLE_ACCORDION_ITEM, payload: { name, item } };
}

export const OPEN_MODAL = 'OPEN_MODAL';
export function openModal(id) {
  return { type: OPEN_MODAL, payload: { id } };
}

export const CLOSE_MODAL = 'CLOSE_MODAL';
export function closeModal(id) {
  return { type: CLOSE_MODAL, payload: { id } };
}

export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';

export function openConfirmationModalThen(message, onConfirm) {
  return { type: OPEN_MODAL, payload: { id: CONFIRMATION_MODAL, message, onConfirm } };
}
export function closeConfirmationModal() {
  return { type: CLOSE_MODAL, payload: { id: CONFIRMATION_MODAL } };
}

export const TOGGLE_FILTER_SELECT_OPEN = 'TOGGLE_FILTER_SELECT_OPEN';
export function toggleFilterSelectOpen(id) {
  return { type: TOGGLE_FILTER_SELECT_OPEN, payload: id };
}

export const COLLAPSE_ALL_ACCORDION_ITEMS = 'COLLAPSE_ALL_ACCORDION_ITEMS';
export function collapseAllAccordionItems(name) {
  return { type: COLLAPSE_ALL_ACCORDION_ITEMS, payload: { name } };
}

export const EXPAND_ACCORDION_ITEMS = 'EXPAND_ACCORDION_ITEMS';
export function expandAccordionItems(name, items) {
  return { type: EXPAND_ACCORDION_ITEMS, payload: { name, items } };
}

export const SET_USER_FIELD_COUNT = 'SET_USER_FIELD_COUNT';
export function setUserFieldCount(count) {
  return { type: SET_USER_FIELD_COUNT, payload: count };
}
